/** @format */

export function getRevisionId() {
  return this.state.project.revisionId;
}
